import {
  ColorArea as AriaColorArea,
  ColorAreaProps,
  ColorThumb,
} from "react-aria-components";
import { css } from "@emotion/css";

export function ColorArea(props: ColorAreaProps) {
  return (
    <AriaColorArea {...props} className={styles.colorArea}>
      <ColorThumb className={styles.colorThumb} />
    </AriaColorArea>
  );
}

const styles = {
  colorArea: css({
    height: 192,
    borderRadius: 4,
    flexShrink: 0,
  }),
  colorThumb: css({
    border: "2px solid white",
    boxShadow: "0 0 0 1px black, inset 0 0 0 1px black",
    width: 20,
    height: 20,
    borderRadius: "50%",
    boxSizing: "border-box",
    "&[data-focus-visible]": {
      width: 24,
      height: 24,
    },
  }),
};
